import React from 'react';
import styled from 'styled-components';
import {
	FooterMobile
} from './../../components';
import { Helmet } from 'react-helmet';
import iconApp from '../../assets/images/Icon-App.png';
import imageAppStore from '../../assets/images/app-store.svg';
import imagePlaystore from '../../assets/images/play-store.svg';
import imageMockup from '../../assets/images/Mock-Up-Application.png';
import { Row, Col } from 'react-bootstrap';
import './style.css';

const TextHeader = styled.div`
	font-size: 46px;
	color: #000000;
	font-weight: 700;
`;

const TextContent = styled.div`
	font-size: 22px;
	color: #000000;
  margin-top: 10px;
  line-height: 1.5;

	&:last-child {
		margin-bottom: 10px;
	}
`;

class NotiDownloadApp extends React.Component {
	render() {
		return (
			<div className="backgroundCirclenotiApp"> 
				<Helmet>
					<title>Download App | GIZTIX บริการขนส่ง บริษัทขนส่ง รถรับจ้าง รถส่งของ รถ6ล้อรับจ้าง รถกระบะรับจ้าง รถส่งสินค้า ส่งสินค้าด่วน</title>
					<meta name="description" content="สามารถเช็คราคาและจองบริการขนส่ง ทั้งแอปพลิเคชันบนมือถือ แทบเล็ต ให้ธุรกิจคุณสะดวกขึ้น" />
				</Helmet>
				<div className="container" style={{ paddingTop: 80 }}>
					
          <img src={iconApp} alt="App giztix" width="80px" />

					<Row style={{ marginTop: 60 }}>
						<Col xs={12}>
							<TextHeader>สะดวกและรวดเร็วกว่า</TextHeader>
							<TextContent>
              สามารถเช็คราคาและจองบริการขนส่ง <br/>
              ทั้งแอปพลิเคชันบนมือถือ แทบเล็ต <br/>
              ให้ธุรกิจคุณสะดวกขึ้น <br/>
							</TextContent>
							<TextContent>
               <b>ดาวน์โหลดแอปพลิเคชันได้แล้ววันนี้ที่</b>
							</TextContent>
						</Col>
					</Row>

					<Row style={{ marginTop: 20 }}>
						<Col xs={12}>
              <a href="https://play.google.com/store/apps/details?id=com.giztix.app" target="_blank"><img src={imagePlaystore} alt="play Store" width="160px" /></a> 
						</Col>
						<Col xs={12} style={{ marginTop: 10 }}>
              <a href="https://itunes.apple.com/app/id1439755826" target="_blank"><img src={imageAppStore} alt="App Store" width="160px" /></a> 
						</Col>
					</Row>

					<Row style={{ marginTop: 50 }}>
						<Col xs={12}>
						<img src={imageMockup} alt="App Store" width="100%" />
            </Col>
					</Row>
				</div>
        
        <FooterMobile />
			</div>
		);
	}
}

export default NotiDownloadApp;
